export const ANAF_HELPER_LINK =
  'https://mfinante.gov.ro/domenii/informatii-contribuabili/persoane-juridice/info-pj-selectie-dupa-cui';

export const NGOHUB_INFORMATION_URL = 'https://www.ngohub.ro/ro/informatii-generale';
